import { useEffect, useState } from "react";
import discounts_model from "@iscr/models/discounts_model";

export const usePublicDiscountData = () => {
  const [publicDiscountData, setPublicDiscountData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  useEffect(() => {
    const fetchPublicDiscountData = async () => {
      const result = await discounts_model.get_public_discount_data();
      if (result.res === "ok") {
        setPublicDiscountData(result.discounts);
      } else {
        console.warn("Error fetching public discount data:");
      }
    };
    if(!publicDiscountData && !isFetching) {
      setIsFetching(true);
      fetchPublicDiscountData();
    }
 
  }, [setPublicDiscountData,setIsFetching, isFetching, publicDiscountData]);

  return publicDiscountData;
};
